import React from 'react';
import type { LikertResponse } from '../../types/investmentPhilosophy';

interface IPProgressTrackerProps {
  responses: (LikertResponse | null)[];
  currentIndex: number;
  total: number;
}

export const IPProgressTracker: React.FC<IPProgressTrackerProps> = ({
  responses,
  currentIndex,
  total,
}) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1.5">
        <span
          className="font-mono text-xs"
          style={{ color: 'hsl(var(--muted-foreground))' }}
        >
          Question {currentIndex + 1} of {total}
        </span>
      </div>
      <div className="flex gap-1">
        {Array.from({ length: total }, (_, i) => {
          let bg: string;
          if (responses[i] != null) {
            bg = 'var(--clue-green-accent)';
          } else if (i === currentIndex) {
            bg = 'var(--clue-green-mid)';
          } else {
            bg = 'var(--clue-border-light)';
          }
          return (
            <div
              key={i}
              className="flex-1 h-1.5 rounded-full transition-colors duration-300"
              style={{ backgroundColor: bg }}
            />
          );
        })}
      </div>
    </div>
  );
};
